import { formatDate, formatTime } from "../formatUtilities";

const requiredValidation = (value) => {
    if (typeof value === "string") {
      return value?.trim() ? true : false;
    } else {
      return value ? true : false;
    }
  }; //helper for createValidator
  
  export const createValidator = (attributes) => {
    const {
      required,
      maxLength,
      minLength,
      min,
      max,
      maxDate,
      minDate,
      regex,
      regexMessage,
      label,
      minDateField,
      maxDateField,
      isDate,
    } = attributes;
    return (value) => {
      if (required && !requiredValidation(value)) {
        return `${label} is required`;
      }
  
      if (value) {
  
        if (maxLength !== undefined && value.trim().length > maxLength) {
          return `${label} may not be over ${maxLength} characters`;
        }
  
        if (
          minLength !== undefined &&
          value.trim() &&
          value.trim().length < minLength
        ) {
          return `${label} must be at least ${minLength} characters`;
        }
  
        if (max !== undefined && value > max) {
          return `${label} may not be greater than ${max}`;
        }
  
        if (min !== undefined && value < min) {
          return `${label} may not be less than ${min}`;
        }
  
        if (maxDate && value > maxDate) {
          return maxDateField
            ? `${label} may not be beyond ${maxDateField} (${formatDate(
                maxDate
              )} ${formatTime(maxDate)})`
            : `${label} may not be beyond ${formatDate(maxDate)} ${formatTime(
                maxDate
              )}`;
        }
        if (minDate && value < minDate) {
          return minDateField
            ? `${label} may not be before ${minDateField} (${formatDate(
                minDate
              )} ${formatTime(minDate)})`
            : `${label} may not be before ${formatDate(minDate)} ${formatTime(
                minDate
              )}`;
        }
  
        if (isDate) {
          if (value && !value._isValid) {
            return regexMessage;
          }
          
        } else if (regex && !regex.test(value)) {
          return regexMessage;
        }
      }
      return true;
    };
  }; //creates validation function based on attributes
  
  export const checkField = (field) => {
    if (field.required || field.visited) {
      return field.validation(field.value);
    }
    return true;
  }; //helper to validate fields, only for form submission, not for onChange
  
  export const handleFailedField = (field, valid) => {
    field.visited = true;
    field.valid = false;
    if (valid !== false) {
      field.errorMessage = valid;
    }
  }; //helper for validateForm - displays error

export const validateFieldset = (fieldsToValidate, stateFields, setStateFields, displayErrors = false) => {
    fieldsToValidate = fieldsToValidate.map((field) => {
      return { valid: checkField(field), index: field.index };
    });
    if (fieldsToValidate.find((field) => field.valid !== true)) {
      if (displayErrors) {
        const tempFields = { ...stateFields };
        fieldsToValidate
          .filter((field) => field.valid !== true)
          .forEach((field) => {
            const propName = Object.keys(stateFields)[field.index];
            const formField = tempFields[propName];
            handleFailedField(formField, field.valid);
          });
        setStateFields(tempFields);
      }
      return false;
    }
    return true;
  };//validates a set of fields, optionally displaying the errors by resetting the fields' state

export  const validatePersonArray = (personArray, setPersonArray, displayErrors) => {
    const personResults = [];
    personArray.forEach((person, index) => {
      const setPerson = (item) => {
        const oldArray = [...personArray];
        oldArray[index] = item;
        setPersonArray(oldArray);
      };
      const personFields = Object.values(person)
        .map((obj, index) => {
            return {...obj, index: index};
        });
      personResults.push(validateFieldset(personFields, person, setPerson, displayErrors));
    });
    return personResults.every(result => result === true);
  };//validates an array of fieldsets

  export const confirmEmailValidator = (theField, contactEmail, label) => {
    return (value) => {
      if (!value) {
        return `${label} is required`;
      }
      if (value !== contactEmail) {
        return "Email addresses do not match";
      }
      const validation = createValidator({
        ...theField.additionalProps,
        ...theField.regex,
        label: theField.label,
        required: theField.required,
      });
      return validation(value);
    };
  };//special validation function for the confirm email field
  
  export const timeValidator = (theField, date) => {
    const todaysDate = new Date().toLocaleDateString("fr-ca");
    const now = new Date().toLocaleTimeString("en-US", { hour12: false });
    return (value) => {
      const validation = createValidator({
        ...theField.additionalProps,
        ...theField.regex,
        label: theField.label,
        required: theField.required,
      });
      if (validation(value) === true) {
        if (value && date >= todaysDate && value > now) {
          return `The Time of Incident may not be in the future`;
        }
      } else {
        return validation(value);
      }
      return true;
    };
  };//special validation for a time field that cannot be in the future when the date is today